import { DocumentDiff, PropertyComparison } from 'types/dynamic-forms/DocumentDiff';
import { ResolvedRowValue } from '../version-log/valueFormat';

/** Combines property comparisons for the data actually used by a rendered row. */
export function getRowComparison(
  left: ResolvedRowValue | null,
  right: ResolvedRowValue | null,
  diff: DocumentDiff
): PropertyComparison {
  const paths = new Set([...(left?.propertyPaths ?? []), ...(right?.propertyPaths ?? [])]);
  const comparisons = Array.from(paths, (path) => diff[path]);
  // Missing diff entries carry no schema information; retain the existing permissive fallback.
  const isDefinedInSchemaA = comparisons.some((comparison) => comparison?.isDefinedInSchemaA !== false);
  const isDefinedInSchemaB = comparisons.some((comparison) => comparison?.isDefinedInSchemaB !== false);
  const isEmptyA = !isDefinedInSchemaA || !left?.hasValue;
  const isEmptyB = !isDefinedInSchemaB || !right?.hasValue;
  const state =
    isEmptyA && isEmptyB
      ? 'Equal'
      : isEmptyA
      ? 'AddedInB'
      : isEmptyB
      ? 'RemovedFromB'
      : comparisons.some((comparison) => comparison && comparison.state !== 'Equal')
      ? 'Changed'
      : 'Equal';

  return { state, isEmptyA, isEmptyB, isDefinedInSchemaA, isDefinedInSchemaB };
}
